import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class ContributionMustBeMoreThan20 extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        let reimbursement = candidate.procedures.map(i => i.reimbursement).reduce((a,b) => a+ b,0);
        let implantReimbursement = candidate.procedures.map(i => i.implantReimbursement).reduce((a,b) => a+ b,0);
        let totalReimbursement = reimbursement + implantReimbursement;
        let cost = candidate.procedures.map(i => i.implantCost).reduce((a,b) => a+b,0);
        let contributionMargin = totalReimbursement - cost;
        let contributionMarginRatio = (contributionMargin / totalReimbursement) * 100;

        if(totalReimbursement === 0)
            return true;
        
        return contributionMarginRatio >= 20;
    }
    
}